import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlUtil } from "app/utils/url.util";
import { of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { ALL_MODULES_AND_FEATURES_LIST } from "./stub";

@Injectable({ providedIn: "root" })
export class PlansService {
  constructor(
    private http: HttpClient,
    private urlUtil: UrlUtil,
    private _translateService: TranslateService
  ) {}

  public getPlansList() {
    return this.http.get(this.urlUtil.getUrl("plans", "getAll")).pipe(
      map((resp: any) => {
        if (resp instanceof Array) {
          return resp;
        }

        return resp;
      }),
      catchError((e) => {
        console.log("getPlansList error =>", e);
        return of([]);
      })
    );
  }

  public modulesAndFeaturesList() {
    return this.http.get(this.urlUtil.getUrl("plans", "getAllModulesAndFeatures")).pipe(
      map((resp: any) => {
        const { status, data, jsonData, errorMessage } = resp;

        if (status) {
          return data;
        } else {
          console.log("modulesAndFeaturesList error =>", errorMessage || jsonData || this._translateService.instant("ErrorGeneral"));
          return [];
        }
      }),
      catchError((e) => {
        console.log("modulesAndFeaturesList error =>", e);
        return of(ALL_MODULES_AND_FEATURES_LIST);
      })
    );
  }

  public getPlansById(id: string = null) {
    return this.http.get(this.urlUtil.getUrl("plans", "searchById").replace("$ID", id)).pipe(
      map((resp: any) => {
        const { status, data, jsonData, errorMessage } = resp;

        if (status) {
          return data;
        } else {
          console.log("getPlansById error =>", errorMessage || jsonData || this._translateService.instant("ErrorGeneral"));
          return {};
        }
      }),
      catchError((e) => {
        console.log("getPlansById error =>", e);
        return of({});
      })
    );
  }

  public getPlanTemplateById(id: string = null) {
    return this.http.get(this.urlUtil.getUrl("plans", "getTemplateById").replace("$ID", id)).pipe(
      map((resp: any) => {
        const { status, data, jsonData, errorMessage } = resp;

        if (status) {
          return data;
        } else {
          console.log("getPlanTemplateById error =>", errorMessage || jsonData || this._translateService.instant("ErrorGeneral"));
          return {};
        }
      }),
      catchError((e) => {
        console.log("getPlanTemplateById error =>", e);
        return of({});
      })
    );
  }

  public addPlans(payload) {
    const { code, name, description, planId } = payload;
    return this.http.post(this.urlUtil.getUrl("plans", "add").replace("$ID", planId), { code, name, description }).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage } = resp;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataAddSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataAdd")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        const { message, errorMessage } = e;
        return of({
          status: false,
          message: message || errorMessage || this._translateService.instant("FailDataAdd")
        });
      })
    );
  }

  public updatePlans({ id, ...data }) {
    return this.http.put(this.urlUtil.getUrl("plans", "update").replace("$ID", id), data || {}).pipe(
      map((resp: any) => {
        const { status, jsonData, errorMessage } = resp;
        if (status) {
          return {
            status: status,
            message: this._translateService.instant("DataUpdateSuccess")
          };
        } else {
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataUpdate")
          };
        }
      }),
      catchError((e) => {
        console.log(e);
        return of({
          status: false,
          message: this._translateService.instant("FailDataUpdate")
        });
      })
    );
  }

  public deletePlans(payload: any = []) {
    return this.http
      .delete(this.urlUtil.getUrl("plans", "delete"), {
        body: payload
      })
      .pipe(
        map((resp: any) => {
          const { status, jsonData, errorMessage, data } = resp;
          if (status && payload.length === data.deletedId?.length) {
            return {
              status: true,
              message: errorMessage || jsonData || this._translateService.instant("DataDeleteSuccess"),
              data: null
            };
          }
          return {
            status: false,
            message: errorMessage || jsonData || this._translateService.instant("FailDataDelete"),
            data: null
          };
        }),
        catchError((e) => {
          console.log(e);
          return of({
            status: false,
            message: this._translateService.instant("FailDataDelete")
          });
        })
      );
  }
}
